module.exports = __webpack_public_path__ + "img/credito-simple-gf.46e63840.webp";